import {
    RESET_PROJECT,
    SET_PROJECT_NAME,
    SET_PROJECT_SKILL,
    SET_PROJECT_STUDENT,
    SET_PROJECT_CUSTOMER,
    SET_PROJECT_CUSTOMER_STATUS,
    SET_PROJECT_MESSAGE,
    SET_PROJECT_STEP,
} from './_types';

export default {
    [RESET_PROJECT](state) {
        state.project = Object.assign({}, state.emptyProject);
    },

    [SET_PROJECT_NAME](state, name) {
        state.project.name = name;
    },

    [SET_PROJECT_SKILL](state, skill) {
        state.project.skill = skill;
    },

    [SET_PROJECT_STUDENT](state, student) {
        state.project.student = student;
    },

    [SET_PROJECT_CUSTOMER](state, customer) {
        state.project.customer = customer;
    },

    [SET_PROJECT_CUSTOMER_STATUS](state, status) {
        state.project.customerStatus = status;
    },

    [SET_PROJECT_MESSAGE](state, message) {
        state.project.message = message;
    },

    [SET_PROJECT_STEP](state, step) {
        state.step = step;
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/students/store/contactForm/_mutators.js